import { Typography, RadioGroup, Radio, FormControlLabel } from '@mui/material'
import { IMPORT_TYPE_OPTIONS } from 'config'

import { RadioGroupChangeHandler } from './types'

interface Props {
  value: string
  disabled?: boolean
  onChange: RadioGroupChangeHandler
}

const ImportTypeRadioGroup = ({ value: groupValue, disabled, onChange }: Props) => {
  const labels = IMPORT_TYPE_OPTIONS.map(({ value, label }) => (
    <FormControlLabel
      key={value}
      value={value}
      control={<Radio color="primary" size="small" disabled={disabled} />}
      label={<Typography variant="body2">{label}</Typography>}
    />
  ))

  return (
    <RadioGroup
      name="importType"
      value={groupValue}
      onChange={onChange}
      data-testid="reading-method"
    >
      {labels}
    </RadioGroup>
  )
}

export default ImportTypeRadioGroup
